<div class="date-picker-container">
    <input
        type="text"
        [formControl]="control"
        [placeholder]="this.datePlaceholder"
        name="dp"
        ngbDatepicker
        [minDate]="{ year: 1900, month: 1, day: 1 }"
        #datepicker="ngbDatepicker"
        readonly="readonly"
        [ngClass]="{
            'highlight-animated': highlightAnimated,
            'highlight-focused': highlightFocused
        }"
        (click)="onHighlightFocus()"
        (focus)="onHighlightFocus()"
        (ngModelChange)="onChange($event)"
    />
    <div class="icon-container" *ngIf="!readonly">
        <app-icon name="calendar-days" type="solid" (click)="datepicker.toggle()" />
    </div>
</div>
